module.exports = __webpack_public_path__ + "static/media/believe.95adc1ce.jpg";